import type { BlogPost } from '../../types/blog';
import { post as copaDoMundo2026 } from './copa-do-mundo-2026';
import { post as brasileirao2026 } from './brasileirao-2026';
import { post as copaDoBrasil2026 } from './copa-do-brasil-2026';
import { post as libertadores2026 } from './libertadores-2026';
import { post as championsLeague2026 } from './champions-league-2026';
import { post as estaduaisBrasileiros } from './estaduais-brasileiros';
import { post as comoAcertarMaisPalpites } from './como-acertar-mais-palpites';
import { post as placarExatoVsVencedor } from './placar-exato-vs-vencedor';
import { post as errosComunsIniciantes } from './erros-comuns-iniciantes';
import { post as mandanteVisitante } from './mandante-visitante';
import { post as maiorViradaCopas } from './maior-virada-copas';
import { post as timesNuncaCairam } from './times-nunca-cairam';
import { post as recordesBrasileirao } from './recordes-brasileirao';
import { post as bolaoEntreAmigos } from './bolao-entre-amigos';

// Registry de todos os posts do blog. Cada arquivo de post exporta uma const
// chamada `post: BlogPost` e este index agrega todos. A ordenação cronológica
// reversa é feita em lib/blog.ts (getAllPosts).
//
// Ao adicionar um novo post:
//  1. Criar `apps/web/src/content/blog/{slug}.tsx` exportando `export const post`
//  2. Importar acima e adicionar no array `ALL_POSTS` abaixo
//  3. Adicionar entrada correspondente em `landing-pages.config.ts` (Dia 10)

export const ALL_POSTS: BlogPost[] = [
  copaDoMundo2026,
  brasileirao2026,
  copaDoBrasil2026,
  libertadores2026,
  championsLeague2026,
  estaduaisBrasileiros,
  comoAcertarMaisPalpites,
  placarExatoVsVencedor,
  errosComunsIniciantes,
  mandanteVisitante,
  maiorViradaCopas,
  timesNuncaCairam,
  recordesBrasileirao,
  bolaoEntreAmigos,
];
